import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { environment } from '@environments/environment';

/**
 * MSAL message logger
 *
 * @param logLevel  log level
 * @param message   message
 */
export function loggerCallback(logLevel: LogLevel, message: string) {
  if ([LogLevel.Error, LogLevel.Warning].includes(logLevel)) console.log(message);
}

/**
 * MSAL creation factory. Used when initialising the MSAL services for the first time.
 *
 * @returns
 */
export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

/**
 * MSAL factory for request interception and processing.
 *
 * @returns
 */
export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  // Defines MS Graph resource which manages the user information within the UI
  environment.apiConfig.forEach((config) => {
    protectedResourceMap.set(
      config.uri,
      config.scopes
    );
  });

  // Default to redirect
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

/**
 * MSAL route guard
 *
 * @returns
 */
export function msalGuardConfigFactory(): MsalGuardConfiguration {
  const scopes = environment.apiConfig.map(config => config.scopes).flat();
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: scopes,
    },
    loginFailedRoute: '/login',
  };
}
